import { render } from "./LocaleInput.vue?vue&type=template&id=5244a637"
import script from "./LocaleInput.vue?vue&type=script&lang=js"
export * from "./LocaleInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__